module.exports = __webpack_public_path__ + "static/media/Chalmers.4716c8d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Chalmers.png
// module id = 109
// module chunks = 0